<script setup lang="ts">
import Typography from '@components/Typography.vue';
import { useStreetDistrict } from '@composables/useStreetDistrict.ts';
import type { CommonAddress } from '@models/interfaces/commonAddress';

const { address } = defineProps<{ address: Pick<CommonAddress, 'street' | 'zip_code' | 'city'> }>();

const { formattedStreetDistrict } = useStreetDistrict(address);
</script>

<template>
  <Typography
    as="span"
    variant="body-bold"
    class="offer-card__title"
  >
    {{ formattedStreetDistrict }}
  </Typography>
</template>
